import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { hasAnyRole } from "@/utils/accessControl";
import { getDefaultAuthorizedRoute } from "@/utils/defaultAuthorizedRoute";

interface RoleGuardProps {
  roles: readonly string[];
  children: React.ReactNode;
  fallbackPath?: string;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
  roles,
  children,
  fallbackPath,
}) => {
  const { t } = useTranslation();
  const { userProfile, isLoading } = useAuthenticatedUser();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  if (!hasAnyRole(userProfile, roles)) {
    return (
      <Navigate
        replace
        to={fallbackPath ?? getDefaultAuthorizedRoute(userProfile)}
      />
    );
  }

  return <>{children}</>;
};
